const { default: BookFormPage } = require("./BookFormPage")

const BookCreate = () => {
	return (
		<BookFormPage></BookFormPage>
	)
}
export default BookCreate;